import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { mapActions, mapState, mapGetters } from 'vuex';
let MyAppointments = class MyAppointments extends Vue {
    areDataLoading;
    currentAuthUser;
    getAppointmentsFromStore;
    fetchMyAppointments;
    get params() {
        return {
            query: {
                'services.userId': this.currentAuthUser._id,
                startAt: {
                    $gte: this.$moment().startOf('day').format(),
                    $lte: this.$moment().endOf('day').format(),
                },
                $sort: { startAt: 1 }
            }
        };
    }
    get appointments() {
        return this.getAppointmentsFromStore(this.params).data;
    }
    created() {
        this.fetchMyAppointments(this.params);
    }
};
MyAppointments = __decorate([
    Component({
        computed: {
            ...mapState('appointment', { areDataLoading: 'isFindPending' }),
            ...mapGetters('appointment', { getAppointmentsFromStore: 'find' }),
            ...mapState('auth', { currentAuthUser: 'user' }),
        },
        methods: {
            ...mapActions('appointment', { fetchMyAppointments: 'find' }),
        }
    })
], MyAppointments);
export default MyAppointments;
;
